import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from 'react-responsive';
import { ColumnHeader } from './ColumnHeader';
import { TableRow } from './TableRow';

export class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = ({
      dataSortField: this.props.dataSortField,
      sortDirection: this.props.sortDirection,
    });

    this.columnHeaderClick = this.columnHeaderClick.bind(this);
  }
  /* Indicates width breakpoint when at least one column is collapsed */
  getCollapsedWidth = () => {
    let width = 0;
    this.props.columns.forEach((column) => {
      if (width < column.maxCollapsedWidth) {
        width = column.maxCollapsedWidth;
      }
    });
    return width;
  }

  getRowsToRender = () => {
    if (this.state.direction && this.state.sortFunc) {
      return this.props.data.sort(
        (a, b) => this.state.sortFunc(a, b, this.state.direction));
    }
    return this.props.data;
  }

  columnHeaderClick(sortFunc, dataSortField, direction) {
    if (this.props.onSortChange) {
      this.props.onSortChange(dataSortField, direction);
    }

    this.setState({
      dataSortField,
      sortDirection: direction.toUpperCase(),
      sortFunc,
      direction,
    });
  }

  getRowClassName = (row, rowClickClosure) => {
    let rowClassName = row.flag ? 'outside-range-row' : '';
    if (rowClickClosure) {      
      rowClassName = rowClassName + ' clickable';
      rowClassName = rowClassName.trim();      
    }
    if (row.isSelected) {
      rowClassName = rowClassName + ' highlighted-row';
      rowClassName = rowClassName.trim();      
    }
    return rowClassName;
  }

  render() {
    const { columns } = this.props;
    const columnsCollapsedWidth = this.getCollapsedWidth();
    
    return (
      <table className={`table ${this.props.className || ''} ${this.props.notReversed ? '' : 'reversed'}`}>
        <thead>
          <tr>
            <MediaQuery maxWidth={columnsCollapsedWidth}>
              <th />
            </MediaQuery>

            {columns.map((column, index) => (
              <MediaQuery key={index} minWidth={column.maxCollapsedWidth ? column.maxCollapsedWidth : 0}>
                <ColumnHeader
                  hidden={column.hidden}
                  currentTableSortField={this.state.dataSortField}
                  sortDirection={ this.state.sortDirection }
                  key={index}
                  dataField={column.dataField}
                  formatted={column.formatted}
                  sortable={ column.dataSort }
                  handleClick={this.columnHeaderClick}
                  sortFunc={column.sortFunc}
                  name={column.name}
                  className={column.headerCellCss ? column.headerCellCss : ''}
                />
              </MediaQuery>
            ))}
          </tr>
        </thead>

        {this.getRowsToRender().map((rowData, rowIndex) => (
          <TableRow key={rowIndex}
            data={rowData}
            columns={this.props.columns}
            className={this.getRowClassName(rowData, this.props.rowClickClosure)}
            customExpansion={ this.props.customExpansion }
            rowClicked={this.props.rowClickClosure ? this.props.rowClickClosure(rowData, rowIndex) : null}
          />
        ))}
      </table>
    );
  }
}

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  onSortChange: PropTypes.func,
  sortDirection: PropTypes.oneOf(['ASC', 'DESC']),
  dataSortField: PropTypes.string,
  notReversed: PropTypes.bool,
  customExpansion: PropTypes.bool,
  rowClickClosure: PropTypes.func,
  className: PropTypes.string,
};
